import { Box, FormControlLabel, Grid, Switch, Tab, Tabs, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import NodeSettings from '../components/NodeSettings'
import { getConfig, getIdentity, setConfig } from '../services/miscService'

export interface IIdentity {
    did: string
    displayName: string
    interchangeId: string
    etin: string
    npi: string
    groupNpi: string
    type: string
    clearingHouse: string
}

const BLANK_IDENTITY = {
    did: '',
    displayName: '',
    interchangeId: '',
    etin: '',
    npi: '',
    groupNpi: '',
    type: '',
    clearingHouse: '',
}

enum Section {
    NODE_SETTINGS,
}

const Settings = () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [section, setSection] = useState(Section.NODE_SETTINGS)
    const [identity, setIdentity] = useState<IIdentity>(BLANK_IDENTITY)
    const [rtaEnabled, setRtaEnabled] = useState<boolean | undefined>()

    useEffect(() => {
        const fetchIdentity = async () => {
            const { data: _identity } = await getIdentity()
            setIdentity(_identity)
        }
        const fetchRtaEnabled = async () => {
            const { data: config } = await getConfig()
            const { automaticClaimProcessing } = config
            setRtaEnabled(automaticClaimProcessing)
        }
        fetchIdentity()
        fetchRtaEnabled()
    }, [])

    const onToggleRta = async (newValue: boolean) => {
        setRtaEnabled(undefined)
        await setConfig({ automaticClaimProcessing: newValue })
        setRtaEnabled(newValue)
    }

    const renderSection = () => {
        switch (section) {
            case Section.NODE_SETTINGS:
                return <NodeSettings data={identity} />
        }
    }

    return (
        <Grid container direction="column" style={{ padding: '40px' }}>
            <Grid item>
                <Box style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <Typography variant="h3">Settings</Typography>
                    <FormControlLabel
                        sx={{ marginRight: '0', marginLeft: 'auto' }}
                        labelPlacement="start"
                        label="Real Time Claim Adjudication"
                        disabled={rtaEnabled === undefined}
                        control={
                            <Switch
                                checked={rtaEnabled}
                                onChange={(e) => onToggleRta(e.target.checked)}
                            />
                        }
                    />
                </Box>
            </Grid>
            <Grid item>
                <Box sx={{ marginTop: '30px', borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={section} aria-label="basic tabs example">
                        <Tab label="Node" />
                    </Tabs>
                </Box>
            </Grid>
            <Grid item>{renderSection()}</Grid>
        </Grid>
    )
}

export default Settings
